import { publishBar } from './publish-bar';
export const publishBarContainer = () => {
    const result = document.createElement('publish-bar-container');
    result.appendChild(publishBar());
    return result;
};
